// extracted by mini-css-extract-plugin
module.exports = {"error":"error-page_error__Q_IGI"};